function createSelectors( stateKey, selectors, createStateKeySetter = false ) {
  const rtn = { }
  let pStateKey = stateKey // allow this to change if wanted
  Object.keys( selectors ).forEach( ( key ) => {
    if ( key !== 'default' && typeof selectors[key] === 'function' ) {
      try {
        rtn[key] = ( state, ...args ) => selectors[key]( state[pStateKey], ...args )
      } catch ( err ) { 
        console.log( err )
      }
    }
  } )
  if ( createStateKeySetter && Object.keys( rtn ).length > 0 ) {
    rtn.setStateKey = ( key ) => { pStateKey = key }
  }
  return rtn
}

export default createSelectors
